import LoadingButton from '@/common/components/base/button/loadingButton';
import RadioGroup from '@/common/components/base/input/radioGroup/RadioGroup';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import {
  ONLY_NUMBERS_RULE,
  PERSIAN_LATTER_RULE,
} from '@/common/components/base/input/textInput/textInput.rules';
import PercentageInput from '@/common/components/base/percentageInput/PercentageInput';
import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';
import { OtherDamagedInfoType } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/driver-owner/otherDamagedInfo/OtherDamagedInfo.type';
import { PatchDamagedUserInformationQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchDamagedUserInformation/patchDamagedUserInformationQueryOptions';
import { requiredText } from '@/common/utils/rules/publicRules';
import { useMutation } from '@tanstack/react-query';
import { useFormContext } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';
import { css } from 'styled-system/css';
import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';

const InitialOtherLegalDamaged = () => {
  const { mutate, isPending: loading } = useMutation(
    PatchDamagedUserInformationQueryOptions(),
  );
  const methods = useFormContext<OtherDamagedInfoType>();
  const { id, damagedId } = useParams();
  const navigate = useNavigate();
  const onSubmit = (formData: OtherDamagedInfoType) => {
    mutate(
      {
        id: id as string,
        formData: {
          economic_code: formData?.personal_information?.owner_economic_code,
          name: formData?.personal_information?.owner_name,
          owner_type: formData?.personal_information?.owner_type,
          fault_percentage: formData?.personal_information?.fault_percentage,
          national_id: formData?.personal_information?.national_id,
          registration_number:
            formData?.personal_information?.owner_registration_number,
          birthdate:
            formData.personal_information.birthdate &&
            convertPersianToGregorian(formData.personal_information.birthdate),
        },
        damaged_id: damagedId as string,
      },
      {
        onSuccess: () => {
          navigate(
            ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
              id: id!,
              damagedId: damagedId!,
            }).OTHER_OWNER_INFORMATION.ownerContact,
            { relative: 'path', replace: true },
          );
        },
      },
    );
  };
  return (
    <Flex direction="column" gap={'1rem'} mb={24}>
      <Box>
        <Flex gap={79} mt={8}>
          <RadioGroup
            name="personal_information.owner_type"
            title="نوع مالکیت"
            options={[
              { label: 'حقیقی', value: 'real' },
              { label: 'حقوقی', value: 'legal' },
            ]}
            className={css({ gap: '2rem' })}
            renderRadioButton={(Component) => <Box>{Component}</Box>}
          />
        </Flex>
      </Box>
      <Box>
        <TextInput
          label="نام"
          name="personal_information.owner_name"
          placeholder="نام را وارد کنید"
          rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
          defaultValue=""
        />
      </Box>
      <Box>
        <PercentageInput
          percentage={10}
          label="درصد تقصیر"
          maxPercentage={100}
          name="personal_information.fault_percentage"
          rules={{ required: requiredText, ...ONLY_NUMBERS_RULE }}
          placeHolder="درصد تقصیر را وارد کنید"
        />
      </Box>
      <Box>
        <TextInput
          label="شماره ثبت"
          name="personal_information.owner_registration_number"
          placeholder="شماره ثبت را وارد کنید"
          rules={{ required: requiredText, ...ONLY_NUMBERS_RULE }}
        />
      </Box>
      <Box>
        <TextInput
          label="کد اقتصادی"
          name="personal_information.owner_economic_code"
          placeholder="کد اقتصادی را وارد کنید"
          rules={{ required: requiredText, ...ONLY_NUMBERS_RULE }}
          defaultValue=""
        />
      </Box>
      <Box>
        <TextInput
          label="شناسه ملی"
          name="personal_information.national_id"
          placeholder="شناسه ملی را وارد کنید"
          rules={{ required: requiredText, ...ONLY_NUMBERS_RULE }}
          defaultValue=""
        />
      </Box>
      <Box w="100%">
        <LoadingButton
          onClick={methods.handleSubmit(onSubmit)}
          loading={loading}
          fullWidth
          disabled={!methods?.formState?.isValid}
        >
          ثبت و ادامه
        </LoadingButton>
      </Box>
      <ImagesFabMainModal state={'propertyDamaged'} />
    </Flex>
  );
};
export default InitialOtherLegalDamaged;
